import React from 'react'

const withQueryParams = Component => ({ location, ...rest }) => (
  <Component
    query={new URLSearchParams(location.search)}
    location={location}
    {...rest}
  />
)

export default withQueryParams



// WEBPACK FOOTER //
// ./src/components/withQueryParams.js